var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyOutline = function SvgCopyOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M12.708 7.292V4.167a1.874 1.874 0 0 0-1.875-1.875H4.167a1.874 1.874 0 0 0-1.875 1.875v6.666c0 1.036.839 1.875 1.875 1.875h3.125m1.875-5.416h6.666c1.036 0 1.875.839 1.875 1.875v6.666a1.874 1.874 0 0 1-1.875 1.875H9.167a1.874 1.874 0 0 1-1.875-1.875V9.167c0-1.036.839-1.875 1.875-1.875"
  })));
};
export default SvgCopyOutline;